var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tree-node",
    class: [{
      'tree-node-leaf': _vm.depth > 1 && !_vm.hasChildren
    }]
  }, [_c('div', {
    staticClass: "node-row-wrapper"
  }, [_vm.depth !== 2 && _vm.hasChildren ? _c('div', {
    staticClass: "chev-area",
    style: {
      paddingLeft: _vm.depth > 0 ? _vm.depth * 40 + 'px' : '0'
    }
  }, [_c('ProTreeIcon', {
    attrs: {
      "visible": _vm.hasChildren,
      "expand": _vm.node.expand
    },
    on: {
      "onChange": _vm.toggle
    }
  })], 1) : _c('div', {
    staticClass: "chev-area-placeholder",
    style: {
      width: _vm.depth > 0 ? _vm.depth * 40 + 32 + 'px' : '32px'
    }
  }), _c('div', {
    staticClass: "iw-row node-content-row",
    on: {
      "click": _vm.onChange
    }
  }, [_c('div', {
    staticClass: "node-icon",
    class: _vm.iconClass
  }, [_vm.node.icon ? _c('span', {
    class: ['iconfont', _vm.node.icon, 'unit-iconfont'],
    style: _vm.iconStyle
  }) : _c('span', {
    staticClass: "material-symbols-outlined unit-material-icon",
    class: {
      'fill-1': _vm.depth < 2
    },
    style: _vm.iconStyle
  }, [_vm._v(_vm._s(_vm.materialIconName))])]), _c('div', {
    staticClass: "node-info"
  }, [_c('h4', {
    staticClass: "truncate",
    class: _vm.depth === 0 ? 'font-headline text-base text-iw-on-surface' : 'font-label text-sm text-iw-on-surface font-semibold'
  }, [_vm._v(" " + _vm._s(_vm.node.name) + " ")]), _c('p', {
    staticClass: "font-label text-[11px] text-stone-400 mt-0.5 tracking-wide"
  }, [_vm._v(" " + _vm._s(_vm.node.code) + " ")])]), _c('div', {
    staticClass: "node-actions"
  }, [_vm.node.defaultChecked ? _c('div', {
    staticClass: "online-badge"
  }, [_c('span', {
    staticClass: "online-dot"
  }), _c('span', {
    staticClass: "font-label text-[10px] text-green-700 tracking-wide"
  }, [_vm._v($t("fiqf2", "在线"))])]) : _vm._e(), _c('span', {
    staticClass: "type-tag",
    class: _vm.typeTagClass
  }, [_vm._v(" " + _vm._s(_vm.typeLabel) + " ")]), _vm.node.unitId ? _c('button', {
    staticClass: "favorite-btn",
    class: {
      'favorite-btn--active': _vm.isFavoriteUnit
    },
    attrs: {
      "title": _vm.isFavoriteUnit ? $t("b17iob4", "取消收藏") : $t("hy6x2", "收藏")
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.toggleFavorite.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined",
    class: {
      'fill-1': _vm.isFavoriteUnit
    }
  }, [_vm._v("star")])]) : _vm._e(), _vm._m(0)])])]), _c('transition', {
    attrs: {
      "name": "tree-collapse"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "before-leave": _vm.beforeLeave,
      "leave": _vm.leave,
      "after-leave": _vm.afterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.node.expand && _vm.hasChildren,
      expression: "node.expand && hasChildren"
    }],
    class: ['children-container', {
      'bg-stone-50/40': _vm.depth === 0
    }]
  }, _vm._l(_vm.node.children, function (child) {
    return _c('ProTreeNode', _vm._g(_vm._b({
      key: child.id,
      attrs: {
        "node": child,
        "depth": _vm.depth + 1,
        "favoriteUnitIds": _vm.favoriteUnitIds
      }
    }, 'ProTreeNode', _vm.$attrs, false), _vm.$listeners));
  }), 1)])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "iw-enter-hint flex items-center space-x-1 text-iw-secondary"
  }, [_c('span', {
    staticClass: "font-label text-xs"
  }, [_vm._v($t("owyy2", "进入"))]), _c('span', {
    staticClass: "material-symbols-outlined text-[16px]"
  }, [_vm._v("arrow_forward")])]);
}];
export { render, staticRenderFns };